import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';

import { DynamicLayoutComponent } from '../../component/dynamic-layout-component';
import type { LayoutProps } from './layout-types';
import { getElementsForPosition } from './utils/get-elements-for-position';

const styles = cssMap({
	rowStyle: {
		width: '100%',
	},
});

const REQUIRED_ELEMENTS_COUNT = 1;

const getElementKey = ({ key, pos, index }: { key?: string; pos?: string; index: number }) => {
	if (key && pos) {
		return `${key}-${pos}-${index}`;
	}
	if (key) {
		return `${key}-${index}`;
	}
	if (pos) {
		return `${pos}-${index}`;
	}
	return index;
};

export const TwoRowLayout = ({
	elements,
	key,
	isFoldable = false,
}: LayoutProps): React.JSX.Element | null => {
	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	const topElements = getElementsForPosition(elements, 'top', 0);
	const bottomElements = getElementsForPosition(elements, 'bottom', 1);

	return (
		<Stack xcss={styles.rowStyle} space="space.100">
			<Box xcss={styles.rowStyle}>
				{topElements.map((element, index) => (
					<DynamicLayoutComponent
						component={element}
						position="two-rows-top"
						key={getElementKey({ key, pos: element.attributes?.pos, index })}
						isFoldable={isFoldable}
					/>
				))}
			</Box>
			<Box xcss={styles.rowStyle}>
				{bottomElements.map((element, index) => (
					<DynamicLayoutComponent
						component={element}
						position="two-rows-bottom"
						key={getElementKey({ key, pos: element.attributes?.pos, index })}
						isFoldable={isFoldable}
					/>
				))}
			</Box>
		</Stack>
	);
};
